import { render, staticRenderFns } from "./removeBackground.vue?vue&type=template&id=e716790c&scoped=true&"
import script from "./removeBackground.vue?vue&type=script&lang=js&"
export * from "./removeBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e716790c",
  null
  
)

export default component.exports